import React from 'react';
import { OverlayDisplayDiv } from '../../../../components/UI-Elements/PopoverOverlays/OverlayDisplayDiv';
import { RouteDetails } from '../../RouteDetails/RouteDetails';

interface Props {
  routeId: string;
  setDisplayOverlay: (value: boolean) => void;
}

export const RouteDocumentOverlay: React.FC<Props> = ({ routeId, setDisplayOverlay }) => {
  return (
    <OverlayDisplayDiv setDisplayOverlay={setDisplayOverlay}>
      <div className="flex flex-col flex-1 bg-white h-[90vh] w-[30vw]    p-4 overflow-auto">
        <RouteDetails routeId={routeId} />
      </div>
    </OverlayDisplayDiv>
  );
};
